import { render, staticRenderFns } from "./ExpertCard.vue?vue&type=template&id=4b7a346a&scoped=true&"
import script from "./ExpertCard.vue?vue&type=script&lang=js&"
export * from "./ExpertCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a346a",
  null
  
)

export default component.exports